<template>

    <FloatingPanel>

        <div class="canvas-blocks-modules-blog-BlockPanel">

            <CommonInputs
                :options="options"/>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";

export default {

    extends: AbstractPanel,

    components: {
        CommonInputs,
        FloatingPanel,
    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-modules-blog-BlockPanel {

}

</style>
